import React from 'react';
import { TAPDataDeletionRequest } from '../../components';

const DataDeletionRequest = () => {
  return (
    <>
    <TAPDataDeletionRequest />
    </>
  )
}

export default DataDeletionRequest
